<template>
  <v-expansion-panel class="elevation-0" focusable>
      <v-layout row wrap >
        <v-flex >
          <span :class="inspection.subtitle">{{inspectionTypeText}}</span>
          <a @click.stop="changeInspectionType()">(click to change...)</a>
        </v-flex>
      </v-layout>
    <v-expansion-panel-content v-for="room in inspection.jsonResult" :key="room.id">
      <template v-slot:header>
        <v-layout row wrap>
          <v-flex xs6 :class="roomstate(room)">
            {{ room.name }}
          </v-flex>
          <v-flex xs6 text-xs-right>
            <span class="pr-4" :class="roomstate(room)">
              {{ room.condition }}
            </span>
          </v-flex>
        </v-layout>
      </template>
      <div v-if="room.components && Object.keys(room.components).length > 0">
        <v-list>
          <v-list-tile
            v-for="roomArea in room.components"
            :key="roomArea.id"
            @click="setArea(roomArea)"
          >
            <v-list-tile-content
              class="flex-direction--row justify-content--left align-items--center"
            >
              <span :class="areastate(roomArea)">{{ roomArea.area }}</span>
              <v-chip v-if="roomArea.status" small :class="areastate(roomArea)">
                {{ roomArea.status }}
              </v-chip>
            </v-list-tile-content>
            <v-list-tile-action class="flex-direction--row">
              <v-icon v-if="roomArea.images && roomArea.images.length > 0">text_snippet</v-icon>
              <v-icon v-if="roomArea.note !== ''">content_paste</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </div>
    </v-expansion-panel-content>
    <inspection-area :selectedArea="selectedArea" :show-area-dialog.sync="showAreaDialog"/>
  </v-expansion-panel>
</template>

<script>
import InspectionArea from './details/InspectionArea.vue'

export default {
  name: 'InspectionExpansionPanel',
  components: {
    InspectionArea
  },
  data() {
    return {
      selectedArea: {},
      showAreaDialog: false,
      inspectionTypeText: ''
    }
  },
  props: {
    inspection: {
      type: Object,
      required: true,
    },
  },
  methods: {
    setArea(room_area) {
      this.selectedArea = room_area;
      this.showAreaDialog = true;
    },
    roomstate(room) {
      if (!room.components) {
        return 'alliswell'
      }
      const arr = Object.values(room.components);
      // console.log(arr);
      // return '';

      return arr.filter(a => a.status).find(a => this.areastate(a.status) === 'issues')? 'issues': 'alliswell'
    },
    areastate(area) {
      // console.log(area);
      if (!area.status) {
        return ''
      }
      return area.status && area.status.toUpperCase() !== "CLEAN"? 'issues': 'alliswell'
    },
    changeInspectionType() {
      const panel = this;
      this.$confirm({
        message: `You are determining if the report is a moving in/out report.
          Yes will set it as a moving in/out report.
          or No will set it as regular inspection report.`,
        title: 'Is it a moving in/out report',
        button: {
          yes: 'Yes',
          no: 'No'
        },
        callback: confirm => {
          if (confirm) {
            panel.inspection.subtitle = 'moving_inout';
            panel.inspectionTypeText = 'This is a moving in/out report';
          } else {
            panel.inspection.subtitle = 'normal';
            panel.inspectionTypeText = 'This is a regular inspection report'
          }
        },

      })
    }
  },
  mounted() {
    if (this.inspection.subtitle === 'moving_inout') {
      this.inspectionTypeText = 'This is a moving in/out report';
    } else {
      this.inspectionTypeText = 'This is a regular inspection report'
    }
  }
}
</script>

<style scoped>
  .flex-direction--row {
    flex-direction: row;
  }

  .justify-content--left {
    justify-content: left;
  }

  .align-items--center {
    align-items: center;
  }

  .issues {
    color: red;
  }

  .moving_inout {
    color: purple;
  }

</style>